<template>
  <svg aria-hidden="true" focusable="false" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      d="m479.935 203.705c-2.544-7.831-8.978-13.15-17.148-14.177l-131.602-16.544-56.402-120.05c-3.501-7.452-10.549-11.927-18.782-11.927s-15.281 4.474-18.782 11.927l-56.401 120.05-131.602 16.544c-8.17 1.027-14.604 6.346-17.148 14.177-2.545 7.831-.467 15.917 5.539 21.549l96.745 90.738-24.934 130.273c-1.548 8.087 1.522 15.85 8.184 20.69s14.994 5.361 22.207 1.39l116.193-63.97 116.193 63.97c7.213 3.971 15.545 3.45 22.206-1.389 6.661-4.84 9.733-12.602 8.185-20.69l-24.933-130.275 96.745-90.737c6.005-5.633 8.084-13.718 5.539-21.549zm-165.806 152.767-58.128-32.003-58.128 32.002 12.474-65.171-48.399-45.394 65.837-8.277 28.216-60.058 28.217 60.058 65.836 8.276-48.398 45.393 12.474 65.173z"
      fill-rule="evenodd"
    />
  </svg>
</template>
<script>
export default {
  name: "M4StarSvg"
};
</script>
